import React, { useState } from 'react';
import { Col, Row, Tab } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FiFolder } from 'react-icons/fi';
import { useParams } from 'react-router-dom';
import TabContent from './TabContent';
import './OrderTabs.css';

// const menuItems = [
//   { name: '3D', eventKey: '3D', icon: FiFolder },
//   { name: 'Client Refernce Pics', eventKey: 'client-refernce-pics', icon: FiFolder },
//   { name: 'DWG(CAD & SKETCH UP)', eventKey: 'dwg-cad-sketch-up', icon: FiFolder },
//   { name: 'KBR3', eventKey: 'kbr3', icon: FiFolder },
//   { name: 'MOM', eventKey: 'mom', icon: FiFolder },
//   { name: 'Payment Details', eventKey: 'payment-details', icon: FiFolder },
//   { name: 'PDF', eventKey: 'pdf', icon: FiFolder },
//   { name: 'Project Details', eventKey: 'project-details', icon: FiFolder },
//   { name: 'Quotations', eventKey: 'quotations', icon: FiFolder },
//   { name: 'Renders', eventKey: 'renders', icon: FiFolder },
//   { name: 'Reports', eventKey: 'reports', icon: FiFolder },
//   { name: 'Sign Off Documents', eventKey: 'sign-off-documents', icon: FiFolder },
//   { name: 'Site Pictures', eventKey: 'site-pictures', icon: FiFolder },
//   { name: 'Discussion Docs', eventKey: 'DiscWordDoc', icon: FiFolder },
//   { name: 'Sales BOQ', eventKey: 'salesBOQ', icon: FiFolder },
// ];

const menuItems = [
  { name: 'Site Images', eventKey: 'site-images', icon: FiFolder, availableSubFolders: ['Site Measurement','Design Discussion Brief','1st cut Meeting','2nd Cut Meeting','3D Model','Material Selection','Quotation','Cost Comparison','40% payment collection','Render 3D','2D Validation ','Site Validation','Production Drawing','Quality Check'] },
  { name: 'MOM', eventKey: 'mom', icon: FiFolder, availableSubFolders: ['Site Measurement','Design Discussion Brief','1st cut Meeting','2nd Cut Meeting','3D Model','Material Selection','Quotation','Cost Comparison','40% payment collection','Render 3D','2D Validation ','Site Validation','Production Drawing','Quality Check'] },
  { name: '2D Layouts', eventKey: '2d-layouts', icon: FiFolder, availableSubFolders: ['Site Measurement','Design Discussion Brief','1st cut Meeting','2nd Cut Meeting','3D Model','Material Selection','Quotation','Cost Comparison','40% payment collection','Render 3D','2D Validation ','Site Validation','Production Drawing','Quality Check'] },
  { name: 'Presentation & Renders', eventKey: 'presentation-renders', icon: FiFolder, availableSubFolders: ['Site Measurement','Design Discussion Brief','1st cut Meeting','2nd Cut Meeting','3D Model','Material Selection','Quotation','Cost Comparison','40% payment collection','Render 3D','2D Validation ','Site Validation','Production Drawing','Quality Check'] },
  { name: 'Quotes', eventKey: 'quotes', icon: FiFolder, availableSubFolders: ['Site Measurement','Design Discussion Brief','1st cut Meeting','2nd Cut Meeting','3D Model','Material Selection','Quotation','Cost Comparison','40% payment collection','Render 3D','2D Validation ','Site Validation','Production Drawing','Quality Check'] },
  { name: 'Finance Docs', eventKey: 'finance-docs', icon: FiFolder, availableSubFolders: ['Site Measurement','Design Discussion Brief','1st cut Meeting','2nd Cut Meeting','3D Model','Material Selection','Quotation','Cost Comparison','40% payment collection','Render 3D','2D Validation ','Site Validation','Production Drawing','Quality Check'] }
];

function Documents() {
  const [activeTab, setActiveTab] = useState('3D');
  const { projectId } = useParams();
  const clientId = projectId;

  const handleTabClick = (eventKey) => {
    setActiveTab(eventKey);
  };

  return (
    <Tab.Container activeKey={activeTab}>
      <Row>
        <Col sm={2} style={{borderWidth:'1px',borderStyle:'solid',borderColor:'#F9FAFB',borderRadius:'7px'}}>
          <nav className="nav-menu">
            <ul>
              {menuItems.map((item) => (
                <li
                  key={item.eventKey}
                  className={activeTab === item.eventKey ? 'active' : ''}
                >
                  <Link
                    onClick={() => handleTabClick(item.eventKey)}
                    className="d-flex align-items-center"
                  >
                    {item.icon && <item.icon color="black" size={20} className="me-2" />}
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </Col>
        <Col sm={10} style={{backgroundColor:'#F9FAFB', borderRadius:10, color:'#000', overflowY:'auto', maxHeight:'68vh'}}>
          <Tab.Content>
            {menuItems.map((item) => (
              <Tab.Pane key={item.eventKey} eventKey={item.eventKey} className='p-3'>
                <TabContent 
                  tabName={item.name}
                  clientId={clientId}
                  folder={item.eventKey}
                  availableSubFolders={item.availableSubFolders}
                />
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
}

export default Documents;